import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientAdditionalRecipients } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientAdditionalRecipients/ClientAdditionalRecipients';
import { hasTooFewSigners } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/utils/signingRecipients';
import { useClientAdditionalRecipients } from './hooks/useClientAdditionalRecipients';
export const GetClientAdditionalRecipientsModalContentTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientAdditionalRecipientsModalContent(param) {
    let { draft, setDraft, showReviewerErrors, anyOneSigns = false, testId } = param;
    const { ClientAdditionalRecipientsModalContentTestIds: TID } = useMemo(()=>GetClientAdditionalRecipientsModalContentTID(testId), [
        testId
    ]);
    const { clientContacts, primaryContact, isLoading, onChange, onCreateContact } = useClientAdditionalRecipients(draft, setDraft);
    return /*#__PURE__*/ _jsx(Column, {
        gap: 0,
        testId: TID.Root(),
        children: /*#__PURE__*/ _jsx(ClientAdditionalRecipients, {
            testId: TID.Recipients(),
            clientContacts: clientContacts,
            primaryContact: primaryContact,
            reviewers: draft.reviewers(),
            onChange: onChange,
            onCreateContact: onCreateContact,
            showReviewerErrors: showReviewerErrors,
            signingRule: anyOneSigns ? {
                anyOneSigns,
                tooFewSigners: hasTooFewSigners({
                    anyOneSigns,
                    primaryContact,
                    reviewers: draft.reviewers()
                })
            } : undefined,
            disabled: isLoading
        })
    });
}
